import { ActivatedRoute, Router } from '@angular/router';
import { ApiHelper } from '@sc/pas-common';
import { ClaimService } from 'app/components/claim/claim.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '@sc/pas-common';
var LegacyBypassComponent = /** @class */ (function () {
    function LegacyBypassComponent(api, router, route, http, claimService, authService) {
        var _this = this;
        this.api = api;
        this.router = router;
        this.route = route;
        this.http = http;
        this.claimService = claimService;
        this.authService = authService;
        route.queryParams.subscribe(function (params) {
            var tokenNSIIS = params['t'];
            var token = params['token'];
            var GTM1 = params['utm_source'];
            var GTM2 = params['utm_medium'];
            var GTM3 = params['utm_campaign'];
            _this.redirectTo = params['redirectTo'];
            _this.redirectClaim = params['redirect'];
            if (tokenNSIIS) {
                var p = GTM1 && GTM2 && GTM3 && { utm_source: GTM1, utm_medium: GTM2, utm_campaign: GTM3 };
                _this.authNSIIS(tokenNSIIS, p, _this.deleteParamsOnRedirect(params));
            }
            if (token) {
                _this.auth(token).subscribe(function (data) {
                    if (data) {
                        var sessionData = {
                            jwt: token,
                            userId: data.userId,
                            username: data.username,
                            impersonationUserName: data.impersonationUserName,
                            impersonationUserId: data.impersonationUserId
                        };
                        _this.authService.persistData(sessionData);
                        if (_this.redirectTo) {
                            _this.router.navigate([_this.redirectTo], { queryParams: _this.deleteParamsOnRedirect(params) });
                        }
                        else {
                            _this.router.navigate(['/forbidden']);
                        }
                    }
                });
            }
        });
    }
    LegacyBypassComponent.prototype.authNSIIS = function (token, GTMParams, params) {
        var _this = this;
        if (GTMParams === void 0) { GTMParams = null; }
        this.api.auth(token).subscribe(function (ok) {
            if (ok) {
                _this.authService.auth(null, localStorage.getItem('tk')).subscribe(function () {
                    if (_this.redirectTo) {
                        _this.router.navigate([_this.redirectTo], { queryParams: params });
                    }
                    else if (_this.redirectClaim) {
                        _this.onEvaluateRedirectParam(_this.redirectClaim, GTMParams);
                    }
                    else {
                        _this.evaluateRedirectHome(GTMParams);
                    }
                });
            }
            else {
                _this.router.navigate(['forbidden']);
            }
        }, function (error) {
            _this.router.navigate(['forbidden']);
        });
    };
    LegacyBypassComponent.prototype.auth = function (jwt) {
        this.api.logUser({ jwt: jwt });
        return this.http.get(environment.server.api.auth + "/api/token/ValidateToken?token=" + jwt);
    };
    LegacyBypassComponent.prototype.onEvaluateRedirectParam = function (type, GTMParams) {
        switch (type) {
            case 'siniestros_auto':
                this.claimService
                    .check()
                    .subscribe(function (result) {
                    if (result && result.link) {
                        location.assign(result.link);
                    }
                });
                break;
            default:
                this.evaluateRedirectHome(GTMParams);
                break;
        }
    };
    LegacyBypassComponent.prototype.evaluateRedirectHome = function (GTMParams) {
        if (GTMParams) {
            this.router.navigate(['inicio'], { queryParams: GTMParams });
        }
        else {
            this.router.navigate(['inicio']);
        }
    };
    LegacyBypassComponent.prototype.deleteParamsOnRedirect = function (params) {
        var _params = JSON.parse(JSON.stringify(params));
        delete _params.t;
        delete _params.token;
        delete _params.redirectTo;
        return _params;
    };
    return LegacyBypassComponent;
}());
export { LegacyBypassComponent };
